module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./axios/index.js
// module id = 247
// module chunks = 1